import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface SendContractModalProps {
  opened: boolean;
  contractLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const SendContractModal = ({
  opened,
  contractLabel,
  onClose,
  onConfirm,
  loading,
  isPaused
}: SendContractModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      title={t('contractDetail.sendModalTitle')}
      message={t('contractDetail.sendModalMessage', { number: contractLabel })}
      confirmLabel={t('contractDetail.sendModalConfirm')}
    />
  );
};
